<template>
	<div>
  
		<el-select v-model="child_defaultValue" @change="onChange" :multiple='fieldArguments.multiple ? true : false'
			:collapse-tags='fieldArguments.collapse_tags ? true : false' :placeholder="fieldArguments.placeholder"
			:size="fieldArguments.size?fieldArguments.size:'mini'"
			:clearable="fieldArguments.clearable?fieldArguments.clearable:true">
			<el-option v-if="optionData&&JSON.stringify(optionData)!='[]'" v-for='(item,index) in optionData'
				:key='index' :value="item[field.defaultProps.value]" :label="item[field.defaultProps.label]">
			</el-option>
		</el-select>
	</div>
</template>

<script>
	import Common from './js/Common'

	export default {
    name: 'sls-select',
    mixins:[Common],
		data() {
			return {
        inital_defaultValue:'',
        child_defaultValue:'',
			}
		},
		computed: {
		},
		watch: {
		},
		methods: {
		},

	}
</script>



// WEBPACK FOOTER //
// src/components/solely-fields/SlsSelect.vue